/**
 * Move related articles block to the bottom of the article.
 */
/**
 * Move related articles block right before the footer.
 */
const moveRelatedArticlesBlock = () => {
	const relatedArticleBlocks = document.querySelectorAll(
		'.single-dv-article .wp-block-post-content .dv-related-articles',
	);
	const insertNode = document.querySelector('.wp-site-blocks > .wp-block-group');
	relatedArticleBlocks.forEach((relatedArticleBlock) => {
		// Check if the insertNode exists before attempting to insert the related articles
		if (insertNode) {
			insertNode.appendChild(relatedArticleBlock); // Move the related articles block right before the footer
		}
	});
};

export default moveRelatedArticlesBlock;
